import { useState } from "react";
import { categories, hotItems } from "@/mocks/content";

export default function Gossip() {
  const [active, setActive] = useState("全部");
  const filtered = active === "全部" ? hotItems : hotItems.filter((i) => i.category === active);

  return (
    <section id="gossip" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="mb-2 text-xs font-medium uppercase tracking-widest text-accent-600">Daily Sweet Feed</p>
          <h2 className="font-display text-3xl text-foreground-950 md:text-5xl">高甜瓜料速递</h2>
        </div>
        <div className="flex flex-wrap gap-2">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`whitespace-nowrap cursor-pointer rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === c
                  ? "bg-primary-500 text-white"
                  : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((item) => (
          <article
            key={item.id}
            className="group overflow-hidden rounded-2xl border border-background-200 bg-white transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="relative h-44 overflow-hidden">
              <img
                src={item.image}
                alt={item.title}
                title={item.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs text-white">
                {item.tag}
              </span>
            </div>
            <div className="p-5">
              <div className="mb-2 flex items-center gap-2 text-xs text-foreground-500">
                <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-secondary-800">{item.category}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-fill text-accent-500"></i>
                  {item.heat}热度
                </span>
              </div>
              <h3 className="mb-2 text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                {item.title}
              </h3>
              <p className="mb-4 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              <div className="flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-2">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-heart-3-fill text-[11px]"></i>
                  </span>
                  {item.author} · {item.date}
                </span>
                <span className="flex items-center gap-1 text-accent-600">
                  <i className="ri-eye-line"></i>
                  {item.readMin}分钟
                  <i className="ri-arrow-right-line ml-1 transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}